import { Text } from '@contentful/rich-text-types'
import { Document } from '@contentful/rich-text-types'
import classNames from 'classnames'
import { Asset, AssetFile } from 'contentful'
import Swiper from 'swiper'
import { createOptimizedContentfulImage, getContentfulAsset } from '~/libs/contentful/helpers'

type DialogListItemProps = {
  dialog: DialogItem
  slider: Swiper | null
  idx: number
}

type DialogItem = {
  dialogName?: string | undefined
  userIcon?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
  assistantIcon?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
  userQuestion1?: Document | undefined
  assistantAnswer1?: Document | undefined
  userQuestion2?: Document | undefined
  assistantAnswer2?: Document | undefined
}

export const DialogListItem = ({ dialog, slider, idx }: DialogListItemProps) => {
  const userIcon = getContentfulAsset(dialog.userIcon)
  const assistantIcon = getContentfulAsset(dialog.assistantIcon)

  const getContent = (obj: Document) =>
    obj.content[0].content.reduce((acc: string, item) => {
      if (item.nodeType === 'text') {
        acc += `<span>${item.value}</span>`
      }
      if (item.nodeType === 'hyperlink') {
        acc += `<a href="${item?.data.uri}">${(item?.content[0] as Text).value}</a>`
      }
      return acc
    }, '')

  return (
    <div
      className={classNames({
        'slide-active': slider?.realIndex === idx,
      })}
    >
      <div className="dialog-line">
        <span className="flex text-s justify-center dialog-icon">
          <img
            src={userIcon?.fields?.file?.url}
            alt={userIcon?.fields?.title}
            loading="lazy"
            className="inline-block max-w-14 max-h-30 max-lg:max-w-12 max-lg:max-h-25 max-md:max-w-10 max-md:max-h-15"
          />
        </span>
        <div
          className="inline-block gap-2 py-4 px-6 mt-3 text-s max-w-[323px] bg-white [&>a]:text-blue-60"
          style={{
            borderRadius: '20px 20px 20px 0px',
            boxShadow:
              '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
          }}
          dangerouslySetInnerHTML={{ __html: getContent(dialog?.userQuestion1 as Document) }}
        />
      </div>
      <div className="dialog-line">
        <span className="flex text-s justify-center dialog-icon">
          <img
            src={createOptimizedContentfulImage({ file: assistantIcon?.fields.file as AssetFile })}
            alt={assistantIcon?.fields.title}
            loading="lazy"
            className="inline-block max-w-14 max-h-30 max-lg:max-w-12 max-lg:max-h-25 max-md:max-w-10 max-md:max-h-15"
          />
        </span>
        <div
          className="inline-block gap-2 py-4 px-6 mt-3 text-s max-w-[323px] bg-white [&>a]:text-blue-60"
          style={{
            borderRadius: '20px 20px 20px 0px',
            boxShadow:
              '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
          }}
          dangerouslySetInnerHTML={{ __html: getContent(dialog?.assistantAnswer1 as Document) }}
        ></div>
      </div>
      <div className="dialog-line">
        <span className="flex text-s justify-center">
          <img
            src={userIcon?.fields?.file?.url}
            alt={userIcon?.fields.title}
            loading="lazy"
            className="inline-block max-w-14 max-h-30 max-lg:max-w-12 max-lg:max-h-25 max-md:max-w-10 max-md:max-h-15"
          />
        </span>
        <div
          className="inline-block gap-2 py-4 px-6 mt-3 text-s max-w-[323px] bg-white [&>a]:text-blue-60"
          style={{
            borderRadius: '20px 20px 20px 0px',
            boxShadow:
              '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
          }}
          dangerouslySetInnerHTML={{ __html: getContent(dialog?.userQuestion2 as Document) }}
        ></div>
      </div>
      <div className="dialog-line">
        <span className="flex text-s justify-center w-14 max-lg:w-11 max-md:w-10">
          <img
            src={assistantIcon?.fields?.file?.url}
            alt={assistantIcon?.fields.title}
            loading="lazy"
            className="inline-block max-w-14 max-h-30 max-lg:max-w-12 max-lg:max-h-25 max-md:max-w-10 max-md:max-h-15"
          />
        </span>
        <div
          className="inline-block gap-2 py-4 px-6 mt-3 text-s max-w-[323px] bg-white [&>a]:text-blue-60"
          style={{
            borderRadius: '20px 20px 20px 0px',
            boxShadow:
              '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 1px 2px 0px rgba(15, 56, 113, 0.12)',
          }}
          dangerouslySetInnerHTML={{ __html: getContent(dialog?.assistantAnswer2 as Document) }}
        ></div>
      </div>
    </div>
  )
}
